import {useContext} from 'react';
import {LangContext} from './AppContext';

export default function Header({onSelectLang}){
  const {lang} = useContext(LangContext);

  return (
    <header id="header" className="flex w-full px-6  flex-row items-center">
        <aside className="ml-auto block text-center">            
                <div className="lang-switcher font-bold flex justify-end lang-switcher mb-auto">
                <a href="#" className={`text-xl  ${lang==='fr'?'is-actives':''}`} onClick={() => onSelectLang('fr')}>FR</a>
                <span className="separator my-auto mx-2.5 block border-black h-4 border-l-2 w-0 m-0 bg-black "></span>
                <a href="#" className={`text-xl  ${lang==='en'?'is-actives':''}`} onClick={() => onSelectLang('en')}>EN</a>
            </div>
        </aside>
        <h1></h1>
    </header>
  );
}
